// extracted by mini-css-extract-plugin
export default {"advanced-search-history-table":"advancedSearchHistoryTable_advanced-search-history-table__KRJrG","action-cell":"advancedSearchHistoryTable_action-cell__IUQ8w"};